module.exports = __webpack_public_path__ + "static/media/imgFatherSon.34cbd9ab.jpg";